import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  AcessoOfertaEducacionalStateService,
  CondicaoQualidadeStateService,
  EtapasDeEdicaoService,
  LocalizacaoService,
  MemoriaDeCalculoService,
  PrecoEncargosAdicionaisStateService,
  RelatorioCaqService,
} from '../../services';
import {
  CommonModule,
  DecimalPipe,
  formatDate,
  NgIf,
  PercentPipe,
} from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  FormatoResultado,
  LayoutResultadoService,
} from '../../layouts/layout-resultado/layout-resultado.service';
import { InstituicaoDto } from '../../dtos/instituicao-dto';
import { MatRadioModule } from '@angular/material/radio';
import { EChartsCoreOption } from 'echarts/core';
import { NGX_ECHARTS_CONFIG, NgxEchartsModule } from 'ngx-echarts';
import {
  MemoriaDeCalculoDto,
  ResultadoEtapa1NumerosDeMatriculasDto,
} from '../../dtos';
import { LayoutPrincipalService } from '../../layouts/layout-principal/layout-principal.service';
import { CarregamentoService } from '../../services/carregamento/carregamento.service';
import { FabricaGraficosRelatorioFinanciamentoEscolas } from './fabrica-graficos-relatorio-financiamento-das-escolas.component';
import { PlanejamentoOrcamentarioService } from '../../services/planejamento-orcamentario/planejamento-orcamentario-service';
import { DadosRelatorioCaqDto } from '../../dtos/caq-por-etapa-dto';
import {
  LocalizacaoSelecionada,
  PlanoEducacional,
} from '../../interfaces/location.interface';
import { TipoSimulacao } from '../../enums/simulation-type.enum';
import { EscolasCaqService } from '../../services/escolas-caq/escolas-caq.service';
import { EstatisticasCaqService } from '../../services/estatisticas-caq/estatisticas-caq.service';
import {
  CaqEscolaResumoDto,
  CaqEscolasRespostaDto,
} from '../../dtos/caq-escola-resumo-dto';
import { LayoutIndicadoresService } from '../../layouts/layout-indicadores/layout-indicadores.service';
import { CaqUtils } from '../../utils/CaqUtils';
import { FeatureFlagService } from "../../services/feature-flag/feature-flag.service";
import { MenuSuspensoComponent, OpcaoMenuSuspenso } from "../../shared/menu-suspenso/menu-suspenso.component";
import { TabelaAdicionalModalidadeComponent } from '../../shared/tabela-adicional-modalidade/tabela-adicional-modalidade.component';
import { TabelaSalasDeAulaComponent } from '../../shared/tabela-salas-de-aula/tabela-salas-de-aula.component';
import { baixarArquivo } from '../../utils/arquivo-utils';
import { TabelaDetalhamentoDespesaComponent } from '../../shared/tabela-detalhamento-despesa/tabela-detalhamento-despesa.component';
import {
  RelatorioCaqPorAnoPorEtapaComponent
} from "../../shared/relatorio-caq-por-mes-ano-por-etapa/relatorio-caq-por-mes-ano-por-etapa";
import { LayoutEdicaoService } from '../../layouts/layout-edicao/layout-edicao.service';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { ResultadoMatriculasPorEtapa } from '../../dtos/resultado-matriculas-etapa';

export type ParametrosGraficoTotalMatriculas = {
  creche: number,
  creche0: number,
  creche1: number,
  creche2: number,
  creche3: number,
  preEscola: number;
  ensFunAnosIniciais: number;
  ensFunAnosFinais: number;
  ensMedio: number;
  eja: number;
}

export type ParametrosGraficoMatriculasPorAreaLocalidade = {
  crecheUrbana: number;
  crecheRural: number;

  preEscolaUrbana: number;
  preEscolaRural: number;

  ensFunAnosIniciaisUrbana: number;
  ensFunAnosIniciaisRural: number;

  ensFunAnosFinaisUrbana: number;
  ensFunAnosFinaisRural: number;

  ensMedioUrbana: number;
  ensMedioRural: number;

  ejaUrbana: number;
  ejaRural: number;
}

export type ParametrosGraficoMatriculasPorTurno = {
  crecheParcial: number;
  crecheIntegral: number;
  crecheNoturna: number;
  preEscolaParcial: number;
  preEscolaIntegral: number;
  preEscolaNoturna: number;

  ensFunAnosIniciaisParcial: number;
  ensFunAnosIniciaisIntegral: number;
  ensFunAnosIniciaisNoturna: number;

  ensFunAnosFinaisParcial: number;
  ensFunAnosFinaisIntegral: number;
  ensFunAnosFinaisNoturna: number;

  ensMedioParcial: number;
  ensMedioIntegral: number;
  ensMedioNoturna: number;

  ejaParcial: number;
  ejaIntegral: number;
  ejaNoturna: number;
}

export type ParametrosFinanciamentoDto = {
  receitaPotencialMinima: number;
  despesaRealizada: number;
  despesaNecessaria: number;
  complementacao: number;
  porcentagemComplementacao: number;
  RPEBAposVaatCaq: number;
  complementacaoVaatCaqPercentual: number;
  valorAlunoAnoRPEB: number;
  valorAlunoAnoAposVaatCaq: number;
  valorAlunoMesAposVaatCaq: number;
  valorCaqAno: number;
  valorCaqMes: number;
  media: number;
  menor: number;
  primeiroQuartil: number;
  mediana: number;
  terceiroQuartil: number;
  maior: number;
  creche: number;
  preEscola: number;
  ensAnosIniciais: number;
  ensAnosFinais: number;
  ensMedio: number;
  eja: number;
};

export type Faixa = { min: number; max: number };

export interface EscolasPorFaixaCaq { quantidade: number[]; }

export interface EscolasPorLocalizacao {
  quantidade: Record<string, number>;
  mediaCaqPorLocalizacao: Record<string, number>;
  maiorMediaCaq: number;
  quantidadePorDiferenciada: Record<string, number>;
  mediaCaqPorDiferenciada: Record<string, number>;
  maiorMediaCaqPorDiferenciada: number;
}

export interface EscolasPorPorte {
  quantidade: number[];
  mediaCaqPorPorte: number[];
  maiorMediaCaq: number;
}

export interface CacheEscolasCaq {
  ehAno: boolean;
  totalEscolas: number;
  faixaCaq: EscolasPorFaixaCaq;
  localizacao: EscolasPorLocalizacao;
  porte: EscolasPorPorte;
}

export interface EstatisticasCaq {
  media: number;
  minimo: number;
  primeiroQuartil: number;
  mediana: number;
  terceiroQuartil: number;
  maximo: number;
}

@Component({
  selector: 'app-financiamento-das-escolas',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    NgIf,
    RouterModule,
    FormsModule,
    MatRadioModule,
    NgxEchartsModule,
    DecimalPipe,
    PercentPipe,
    CommonModule,
    MenuSuspensoComponent,
    RelatorioCaqPorAnoPorEtapaComponent,
    TabelaAdicionalModalidadeComponent,
    TabelaSalasDeAulaComponent,
    TabelaDetalhamentoDespesaComponent,
  ],
  providers: [
    {
      provide: NGX_ECHARTS_CONFIG,
      useValue: {
        echarts: () => import('echarts'),
      },
    },
  ],
  templateUrl: './relatorio-financiamento-das-escolas.component.html',
  styleUrl: './relatorio-financiamento-das-escolas.component.scss',
})
export class RelatorioFinanciamentoDasEscolasComponent implements OnInit {
  anosReferencias: AnosReferenciasDto | null = null;
  anoPqr: number;
  anoCenso: number;

  public opcoesFiltroLocalizacao: OpcaoMenuSuspenso[] = [
    {
      rotulo: 'Sem filtros',
      icone: 'deselect',
      acao: 'NENHUM',
    },
    {
      rotulo: 'Urbano',
      icone: 'location_city',
      acao: 'URBANO',
    },
    {
      rotulo: 'Campo',
      icone: 'nature',
      acao: 'CAMPO',
    },
    {
      rotulo: 'Terra indígena',
      icone: 'nature',
      acao: 'TERRA_INDIGENA',
    },
    {
      rotulo: 'Comunidade quilombola',
      icone: 'nature',
      acao: 'QUILOMBOLA',
    },
  ];

  public filtroLocalizacaoEscolhido: OpcaoMenuSuspenso =
    this.opcoesFiltroLocalizacao[0];

  instituicaoSelecionada: InstituicaoDto | undefined;
  quantidadeInstituicoes: number = 0;
  tipoFiltroSelecionado: string = '1';
  tipoFiltroFinanciamentoSelecionado = '1';
  descricaoFiltroFinanciamentoSelecionado = 'ano';

  tituloPlanoEducacional: string | undefined;
  planoSelecionado: PlanoEducacional | undefined;
  localizacaoSelecionada?: LocalizacaoSelecionada | null;

  chartOption: EChartsCoreOption | undefined;
  memoriaCalculo: MemoriaDeCalculoDto | undefined;

  carregandoPdfSalasDeAula = false;

  get mostrarTabelaSalasDeAula(): boolean {
    return this.featureFlagService.funcionalidadeHabilitada('1472-salas-necessarias')
      && !!this.memoriaCalculo?.resultadoParte9_3ResultadoSalasNecessarias;
  }

  get mostrarAdicionalModalidade(): boolean {
    return (
      this.featureFlagService.funcionalidadeHabilitada(
        '995-fator-ponderacao-calculo.exibicao-fator-ponderacao',
      ) &&
      !!this.memoriaCalculo?.resultadoMatriculasFatorPonderacao &&
      !!this.memoriaCalculo?.resultadoDistribuicaoDespesaPorEtapa
    );
  }

  get mostrarDetalhamentoDespesa(): boolean {
    return (
      this.featureFlagService.funcionalidadeHabilitada(
        '995-fator-ponderacao-calculo.exibicao-fator-ponderacao',
      ) && !!this.memoriaCalculo?.resultadoDistribuicaoDespesaPorEtapa
    );
  }
  resultadoEtapa1:
    | ResultadoEtapa1NumerosDeMatriculasDto
    | ResultadoMatriculasPorEtapa
    | undefined;

  dadosRelatorioCaq: DadosRelatorioCaqDto | null = null;

  faixasPorteEscola = [
    { min: 0, max: 100 },
    { min: 101, max: 200 },
    { min: 201, max: 300 },
    { min: 301, max: 400 },
    { min: 401, max: 500 },
    { min: 501, max: 600 },
    { min: 601, max: 700 },
    { min: 701, max: 800 },
    { min: 800, max: Number.MAX_VALUE },
  ];

  //Numero de turmas
  larguraQuantidadeTurmasExistentes: number = 0;
  quantidadeTurmasExistentes: number = 0;
  larguraQuantidadeTurmasNecessarias: number = 0;
  quantidadeTurmasNecessarias: number = 0;
  porcentagemInformacaoNumeroTurmas: number = 0;
  numeroTurmasExistentesEhMaior: boolean = false;

  //Numero de docentes
  larguraQuantidadeDocentesExistentes: number = 0;
  quantidadeDocentesExistentes: number = 0;
  larguraQuantidadeDocentesNecessarias: number = 0;
  quantidadeDocentesNecessarias: number = 0;
  porcentagemInformacaoNumeroDocentes: number = 0;
  numeroDocentesExistentesEhMaior: boolean = false;

  //Numero de funcionários
  larguraQuantidadeFuncionariosExistentes = 0;
  quantidadeFuncionariosExistentes = 0;
  larguraQuantidadeFuncionariosNecessarias = 0;
  quantidadeFuncionariosNecessarias = 0;
  porcentagemInformacaoNumeroFuncionarios = 0;
  numeroFuncionariosExistentesEhMaior = false;

  //Numero de matrículas
  totalMatriculas: number = 0;
  totalMatriculasAreaRural: number = 0;
  porcentagemTotalMatriculasAreaRural: number = 0;
  totalMatriculasIntegral: number = 0;
  porcentagemMatriculasIntegral: number = 0;

  caqEscolas: CaqEscolasRespostaDto | null = null;

  private cacheMes: CacheEscolasCaq | null = null;
  private cacheAno: CacheEscolasCaq | null = null;

  dadosEstatisticos: EstatisticasCaq = {
    media: 0,
    minimo: 0,
    primeiroQuartil: 0,
    mediana: 0,
    terceiroQuartil: 0,
    maximo: 0,
  };

  faixasCaqAnoCalculadas: Faixa[] = [];

  parametrosGraficoTotalMatriculas: ParametrosGraficoTotalMatriculas = {
    creche: 0,
    creche0: 0,
    creche1: 0,
    creche2: 0,
    creche3: 0,
    preEscola: 0,
    ensFunAnosIniciais: 0,
    ensFunAnosFinais: 0,
    ensMedio: 0,
    eja: 0,
  };

  parametrosGraficoMatriculasPorAreaLocalidade: ParametrosGraficoMatriculasPorAreaLocalidade =
    {
      crecheUrbana: 0,
      crecheRural: 0,
      preEscolaUrbana: 0,
      preEscolaRural: 0,
      ensFunAnosIniciaisUrbana: 0,
      ensFunAnosIniciaisRural: 0,
      ensFunAnosFinaisUrbana: 0,
      ensFunAnosFinaisRural: 0,
      ensMedioUrbana: 0,
      ensMedioRural: 0,
      ejaUrbana: 0,
      ejaRural: 0,
    };

  parametrosGraficoMatriculasPorTurno: ParametrosGraficoMatriculasPorTurno = {
    crecheParcial: 0,
    crecheIntegral: 0,
    crecheNoturna: 0,

    preEscolaParcial: 0,
    preEscolaIntegral: 0,
    preEscolaNoturna: 0,

    ensFunAnosIniciaisParcial: 0,
    ensFunAnosIniciaisIntegral: 0,
    ensFunAnosIniciaisNoturna: 0,

    ensFunAnosFinaisParcial: 0,
    ensFunAnosFinaisIntegral: 0,
    ensFunAnosFinaisNoturna: 0,

    ensMedioParcial: 0,
    ensMedioIntegral: 0,
    ensMedioNoturna: 0,

    ejaParcial: 0,
    ejaIntegral: 0,
    ejaNoturna: 0,
  };

  parametrosFinanciamentoDto: ParametrosFinanciamentoDto = {
    receitaPotencialMinima: 0,
    despesaRealizada: 0,
    despesaNecessaria: 0,
    complementacao: 0,
    porcentagemComplementacao: 0,
    complementacaoVaatCaqPercentual: 0,
    RPEBAposVaatCaq: 0,
    valorAlunoAnoRPEB: 0,
    valorAlunoAnoAposVaatCaq: 0,
    valorAlunoMesAposVaatCaq: 0,
    valorCaqAno: 0,
    valorCaqMes: 0,
    media: 0,
    menor: 0,
    primeiroQuartil: 0,
    mediana: 0,
    terceiroQuartil: 0,
    maior: 0,
    creche: 0,
    preEscola: 0,
    ensAnosIniciais: 0,
    ensAnosFinais: 0,
    ensMedio: 0,
    eja: 0,
  };

  Math = Math;

  constructor(
    private carregamentoService: CarregamentoService,
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private layoutPrincipalService: LayoutPrincipalService,
    private memoriaCalculoService: MemoriaDeCalculoService,
    private layoutResultadoService: LayoutResultadoService,
    private planejamentoOrcamentarioService: PlanejamentoOrcamentarioService,
    private relatorioCaqService: RelatorioCaqService,
    private localizacaoService: LocalizacaoService,
    private escolasCaqService: EscolasCaqService,
    private estatisticasCaqService: EstatisticasCaqService,
    private layoutIndicadoresService: LayoutIndicadoresService,
    private acessoOfertaEducacionalStateService: AcessoOfertaEducacionalStateService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private precoEncargosAdicionaisStateService: PrecoEncargosAdicionaisStateService,
    private cdr: ChangeDetectorRef,
    public featureFlagService: FeatureFlagService,
    private layoutEdicaoService: LayoutEdicaoService,
    private anosReferenciasService: AnosReferenciasService,
  ) {
    if (
      this.featureFlagService.funcionalidadeHabilitada(
        '939-migracao-datas-relatorios-3-e-4',
      )
    ) {
      this.anosReferencias =
        this.anosReferenciasService.obterAnosReferenciasSnapshot();
    }
    this.anoPqr = this.anosReferencias?.anoPqr ?? 2026;
    this.anoCenso = this.anosReferencias?.anoCenso ?? 2025;
  }

  async ngOnInit() {
    // Garante que os filtros padrão estejam selecionados
    this.tipoFiltroSelecionado = '1';
    this.tipoFiltroFinanciamentoSelecionado = '1';

    this.localizacaoSelecionada =
      this.localizacaoService.obterLocalizacaoSelecionada();

    this.planoSelecionado = this.localizacaoService
      .obterOpcoesPlanoEducacional(this.localizacaoSelecionada!)
      .find(
        (opcao) =>
          opcao.value === this.localizacaoSelecionada?.tipoSimulacaoSelecionado,
      );

    this.definaConfiguracoesDaPagina();
    this.definaConfiguracoesIndicadores();

    this.layoutPrincipalService.definaMensagensCarregamento([
      'Obtendo dados da memória de cálculo...',
    ]);

    this.carregamentoService.startLoading();

    // Verifica se há dados editados
    const novosDadosForamAdicionados = this.verificaNovosDadosAdicionados();

    const requisicao = this.criarRequisicao();

    const [memoriaCalculo, escolasCaq, variacaoDimensaoOferta, estatisticas] =
      await Promise.all([
        novosDadosForamAdicionados
          ? this.memoriaCalculoService.recalcularMemoriaDeCalculo()
          : this.memoriaCalculoService.buscarMemoriaDeCalculoLocalizacao(),

        novosDadosForamAdicionados
          ? this.escolasCaqService.recarcularMemoriaCalculoEscolas(requisicao)
          : this.escolasCaqService.buscarEscolas(),

        this.planejamentoOrcamentarioService.buscarVariacaoDimensaoOfertaPorLocalizacao(),
        this.atualizarEstatisticas(novosDadosForamAdicionados)
      ]);

    // Atribui os resultados
    this.memoriaCalculo = memoriaCalculo;
    this.caqEscolas = escolasCaq;
    this.resultadoEtapa1 =
      this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade') &&
      memoriaCalculo.resultadoMatriculasPorEtapa
        ? memoriaCalculo.resultadoMatriculasPorEtapa
        : memoriaCalculo.resultadoEtapa1NumerosDeMatriculas;

    this.dadosRelatorioCaq = memoriaCalculo.relatorioCaq || null;

    await this.atualizarEstatisticas(novosDadosForamAdicionados);

    this.faixasCaqAnoCalculadas = this.calcularFaixasCaqAno();

    this.cacheMes = this.construirValoresPorEscola(false);
    this.cacheAno = this.construirValoresPorEscola(true);

    this.resultadoEtapa1 =
      this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade') &&
      this.memoriaCalculo.resultadoMatriculasPorEtapa
        ? this.memoriaCalculo.resultadoMatriculasPorEtapa
        : this.memoriaCalculo.resultadoEtapa1NumerosDeMatriculas;

    this.calcularDadosFinanceiros();

    setTimeout(() => {
      this.carregamentoService.finishLoading();
    }, 1000);

    this.calculeTotais();
    this.crieParametrosTotalMatriculas();
    this.crieParametrosGraficoMatriculasPorAreaLocalidade();

    this.chartOption =
      FabricaGraficosRelatorioFinanciamentoEscolas.crieConfiguracaoGraficoTotalMatriculas(
        this.parametrosGraficoTotalMatriculas,
        this.totalMatriculas,
        this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade'),
      );

    this.quantidadeTurmasExistentes = variacaoDimensaoOferta.numeroTurmas;
    this.quantidadeTurmasNecessarias =
      this.featureFlagService.funcionalidadeHabilitada(
        '1108-pqr-minimo-turma',
      ) &&
      this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade') &&
      this.memoriaCalculo.resultadoCalcNumTurmas
        ? this.memoriaCalculo.resultadoCalcNumTurmas.total || 0
        : this.memoriaCalculo.resultadoEtapa4CalculoNumeroTurmas?.total || 0;

    this.quantidadeDocentesExistentes = variacaoDimensaoOferta.numeroDocentes;
    const resultadoEtapa10 = this.featureFlagService.funcionalidadeHabilitada(
      '1104-creche-idade',
    )
      ? this.memoriaCalculo.resultadoCalcNumProf
      : this.memoriaCalculo.resultadoEtapa10CalculoDemandaPorDocentes;
    this.quantidadeDocentesNecessarias = resultadoEtapa10?.total ?? 0;

    this.quantidadeFuncionariosExistentes =
      variacaoDimensaoOferta.numeroFuncionarios;
    this.quantidadeFuncionariosNecessarias =
      this.memoriaCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total;

    this.definaLarguraGraficoNumeroTurmas();
    this.definaLarguraGraficoNumeroDocentes();
    this.definaLarguraGraficoNumeroFuncionarios();

    this.definaPorcentagemNumeroTurmas();
    this.definaPorcentagemNumeroDocentes();
    this.definaPorcentagemNumeroFuncionarios();

    this.cdr.detectChanges();
  }

  criarRequisicao(): any {
    return {
      diagnosticoDeMatriculaPorEscola:
        this.acessoOfertaEducacionalStateService.getProjecoesOfertaMatriculas(),
      pqrNumeroDiasLetivosList:
        this.condicaoQualidadeStateService.getPQRNumeroDiasLetivosValores(),
      pqrCargaHorariaEnsinosList:
        this.condicaoQualidadeStateService.getPQRCargaHorarioEnsinoValores(),
      pqrTamanhoTurmaList:
        this.condicaoQualidadeStateService.getPQRTamanhoTurmasValores(),
      pqrTamanhoMinimoTurmaList:
        this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade') &&
        this.featureFlagService.funcionalidadeHabilitada(
          '1108-pqr-minimo-turma',
        )
          ? this.condicaoQualidadeStateService.getPQRMinimoTurmasValores()
          : undefined,
      pqrFormacaoJornadaRemuneracaoProfessoresList:
        this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresValores(),
      pqrQuadroFuncionariosRemuneracaoList:
        this.condicaoQualidadeStateService.getPQRQuadroFuncionariosRemuneracaoValores(),
      pqrManutencaoFormacaoMaterialList:
        this.condicaoQualidadeStateService.getPQRManutencaoFormacaoMaterialValores(),
      pqrAlimentacaoEscolarList:
        this.condicaoQualidadeStateService.getPQRAlimentacaoEscolarValores(),
      pqrEncargosSociaisList:
        this.precoEncargosAdicionaisStateService.getPQREncargosSociaisValores(),
      pqrMultiplicadorAnualList:
        this.precoEncargosAdicionaisStateService.getPQRMultiplicadorAnualValores(),
      pqrAdicionaisList:
        this.precoEncargosAdicionaisStateService.getPQRAdicionaisValores(),
      pqrNovasSalasPredioList:
          this.condicaoQualidadeStateService.getPQRNovasSalasPrediosPadrao(),
      overridesNovasConstrucoes:
        this.condicaoQualidadeStateService.getPqrQuantidadeNovasConstrucoesValores(),
      pqrFatorPonderacaoList:
        this.condicaoQualidadeStateService.getPQRFatorPonderacaoValores()
    };
  }

  async baixarPdfSalasDeAula(): Promise<void> {
    this.carregandoPdfSalasDeAula = true;
    try {
      const pdf = await this.memoriaCalculoService.baixarPdfSalasDeAula(
        this.verificaNovosDadosAdicionados()
      );
      // Em caso de erro o CaqRequestService já exibe o aviso e devolve um arquivo vazio.
      if (pdf.size > 0) {
        baixarArquivo(pdf, 'Salas_de_Aula.pdf');
      }
    } finally {
      this.carregandoPdfSalasDeAula = false;
    }
  }

  verificaNovosDadosAdicionados(): boolean {
    return (
      this.acessoOfertaEducacionalStateService.getProjecoesOfertaMatriculas()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPQRNumeroDiasLetivosValores()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPQRCargaHorarioEnsinoValores()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPQRTamanhoTurmasValores()?.length >
        0 ||
      this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresValores()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPQRQuadroFuncionariosRemuneracaoValores()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPQRManutencaoFormacaoMaterialValores()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPQRAlimentacaoEscolarValores()
        ?.length > 0 ||
      this.precoEncargosAdicionaisStateService.getPQREncargosSociaisValores()
        ?.length > 0 ||
      this.precoEncargosAdicionaisStateService.getPQRAdicionaisValores()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPqrQuantidadeNovasConstrucoesValores()
        ?.length > 0 ||
      this.condicaoQualidadeStateService.getPQRFatorPonderacaoValores()
        ?.length > 0 ||
      this.precoEncargosAdicionaisStateService.getPQRMultiplicadorAnualValores()
        ?.length > 0
    );
  }

  definaConfiguracoesDaPagina() {
    this.layoutResultadoService.setTitulo('Financiamento atual x necessário');
    this.layoutResultadoService.setCorTexto('text-crayola-400');
    this.layoutResultadoService.setCorBordaTitulo('border-crayola-400');
    this.layoutResultadoService.setRotaResultado(
      '/resultado/relatorio-financiamento-das-escolas',
    );

    this.layoutResultadoService.setEditavel(true);

    this.layoutResultadoService.setRotaFiltroLocalidade(
      '/filtrar-instituicoes',
    );

    if (this.planoSelecionado?.label) {
      this.layoutResultadoService.setRedeSelecionada(
        this.planoSelecionado.label,
      );
    }

    this.layoutResultadoService.setPais('Brasil');

    if (this.localizacaoSelecionada?.estadoSelecionado) {
      this.layoutResultadoService.setEstado(
        this.localizacaoSelecionada.estadoSelecionado.sigla,
      );
    }

    if (this.localizacaoSelecionada?.cidadeSelecionada?.label) {
      this.layoutResultadoService.setCidade(
        this.localizacaoSelecionada.cidadeSelecionada.label,
      );
    }

    this.layoutResultadoService.setAno(String(this.anoPqr));

    this.definirRotaDownloadResultado();

    this.definirDownloads();

    this.layoutResultadoService.setRotaEdicaoSimulacao(
      'edicao-relatorio-financiamento-das-escolas/acesso-oferta-educacional/diagnostico-matricula',
    );

    this.layoutResultadoService.setTextoComoCitar(
      `SIMULADOR de Custo-Aluno Qualidade: Financiamento atual x necessário, ${this.anoPqr}. Disponível em: <https://simcaq.ufg.br/>. Acesso em: ${formatDate(
        new Date(),
        'dd MMM yyyy',
        'pt-BR',
      )}.`,
    );

    this.layoutResultadoService.setRotaApresentacao(
      '/financiamento-atual-necessario',
    );

    this.layoutResultadoService.setRotaIndicadoresLocais(
      '/indicadores/financiamento-atual-necessario',
    );

    this.layoutResultadoService.setCorTextoRodape('text-crayola-400');
    this.layoutResultadoService.setCorBotaoRodape('bg-crayola-400');
    this.layoutResultadoService.setCorBordaBotaoRodape('border-crayola-400');
    this.layoutEdicaoService.setTituloEdicao(
      'Financiamento atual x necessário',
    );
    this.layoutEdicaoService.setCorTituloEdicao('text-crayola-400');
    this.layoutEdicaoService.setCorBordaEdicao('border-crayola-400');
  }

  definaConfiguracoesIndicadores() {
    this.layoutIndicadoresService.setTituloTag(
      'Financiamento atual x necessário',
    );
    this.layoutIndicadoresService.setCorBordaTag('border-crayola-400');
    this.layoutIndicadoresService.setCorTextoTag('text-crayola-400');
    this.layoutIndicadoresService.setRotaResultado(
      '/resultado/relatorio-financiamento-das-escolas',
    );
    this.layoutIndicadoresService.setRotaFiltroLocalidade(
      '/filtrar-instituicoes',
    );
    this.layoutIndicadoresService.setRotaApresentacao(
      '/financiamento-atual-necessario',
    );
    this.layoutIndicadoresService.setEditavel(true);
  }

  private definirRotaDownloadResultado() {
    const localizacao = this.localizacaoSelecionada;
    const tipoSimulacao = localizacao?.tipoSimulacaoSelecionado;
    const prefixo =
      tipoSimulacao === TipoSimulacao.planejamento ? 'plano' : 'rede';

    if (localizacao?.cidadeSelecionada) {
      this.layoutResultadoService.setRotaDownloadResultado(
        `financiamento-entes-federados/${prefixo}/municipio/${localizacao.cidadeSelecionada.value}/analitico`,
      );
      return;
    }

    if (localizacao?.estadoSelecionado) {
      this.layoutResultadoService.setRotaDownloadResultado(
        `financiamento-entes-federados/${prefixo}/estado/${localizacao.estadoSelecionado.value}/analitico`,
      );
      return;
    }

    this.layoutResultadoService.setRotaDownloadResultado(
      'financiamento-entes-federados/nacional/analitico',
    );
  }

  /**
   * As localizações urbana e rural já conta as escolas com localização diferenciada
   */
  calculeTotais() {
    this.totalMatriculas = this.resultadoEtapa1?.total || 0;

    this.totalMatriculasAreaRural = this.calculeTotalMatriculasAreaRural();
    this.porcentagemTotalMatriculasAreaRural =
      FabricaGraficosRelatorioFinanciamentoEscolas.calculePorcentagem(
        this.totalMatriculasAreaRural,
        this.totalMatriculas,
      );

    this.totalMatriculasIntegral = this.calculeTotalMatriculasIntegral();
    this.porcentagemMatriculasIntegral =
      FabricaGraficosRelatorioFinanciamentoEscolas.calculePorcentagem(
        this.totalMatriculasIntegral,
        this.totalMatriculas,
      );
  }

  calculeTotalMatriculasAreaRural(): number {
    return (
      (this.resultadoEtapa1?.crecheRuralParcial || 0) +
      (this.resultadoEtapa1?.crecheRuralIntegral || 0) +
      (this.resultadoEtapa1?.preEscolaRuralParcial || 0) +
      (this.resultadoEtapa1?.preEscolaRuralIntegral || 0) +
      (this.resultadoEtapa1?.ensFunAnosIniciaisRuralParcial || 0) +
      (this.resultadoEtapa1?.ensFunAnosIniciaisRuralIntegral || 0) +
      (this.resultadoEtapa1?.ensFunAnosFinaisRuralParcial || 0) +
      (this.resultadoEtapa1?.ensFunAnosFinaisRuralIntegral || 0) +
      (this.resultadoEtapa1?.ensMedioRuralParcial || 0) +
      (this.resultadoEtapa1?.ensMedioRuralIntegral || 0) +
      (this.resultadoEtapa1?.ensMedioRuralNoturno || 0) +
      (this.resultadoEtapa1?.ejaRuralParcial || 0) +
      (this.resultadoEtapa1?.ejaRuralNoturno || 0)
    );
  }

  calculeTotalMatriculasIntegral(): number {
    return (
      (this.resultadoEtapa1?.crecheUrbanaIntegral || 0) +
      (this.resultadoEtapa1?.crecheRuralIntegral || 0) +
      (this.resultadoEtapa1?.preEscolaUrbanaIntegral || 0) +
      (this.resultadoEtapa1?.preEscolaRuralIntegral || 0) +
      (this.resultadoEtapa1?.ensFunAnosIniciaisUrbanaIntegral || 0) +
      (this.resultadoEtapa1?.ensFunAnosIniciaisRuralIntegral || 0) +
      (this.resultadoEtapa1?.ensFunAnosFinaisUrbanaIntegral || 0) +
      (this.resultadoEtapa1?.ensFunAnosFinaisRuralIntegral || 0) +
      (this.resultadoEtapa1?.ensMedioUrbanaIntegral || 0) +
      (this.resultadoEtapa1?.ensMedioRuralIntegral || 0)
    );
  }

  crieParametrosTotalMatriculas() {
    const r = this.resultadoEtapa1 as ResultadoMatriculasPorEtapa;
    const somaIdade = (
      p0: number,
      i0: number,
      p1: number,
      i1: number,
      p2: number,
      i2: number,
      p3: number,
      i3: number,
    ) =>
      (p0 || 0) +
      (i0 || 0) +
      (p1 || 0) +
      (i1 || 0) +
      (p2 || 0) +
      (i2 || 0) +
      (p3 || 0) +
      (i3 || 0);
    this.parametrosGraficoTotalMatriculas = {
      creche: this.resultadoEtapa1?.creche || 0,
      creche0: somaIdade(
        r?.crecheUrbana0Parcial,
        r?.crecheUrbana0Integral,
        r?.crecheCampo0Parcial,
        r?.crecheCampo0Integral,
        r?.crecheTerraIndigena0Parcial,
        r?.crecheTerraIndigena0Integral,
        r?.crecheQuilombola0Parcial,
        r?.crecheQuilombola0Integral,
      ),
      creche1: somaIdade(
        r?.crecheUrbana1Parcial,
        r?.crecheUrbana1Integral,
        r?.crecheCampo1Parcial,
        r?.crecheCampo1Integral,
        r?.crecheTerraIndigena1Parcial,
        r?.crecheTerraIndigena1Integral,
        r?.crecheQuilombola1Parcial,
        r?.crecheQuilombola1Integral,
      ),
      creche2: somaIdade(
        r?.crecheUrbana2Parcial,
        r?.crecheUrbana2Integral,
        r?.crecheCampo2Parcial,
        r?.crecheCampo2Integral,
        r?.crecheTerraIndigena2Parcial,
        r?.crecheTerraIndigena2Integral,
        r?.crecheQuilombola2Parcial,
        r?.crecheQuilombola2Integral,
      ),
      creche3: somaIdade(
        r?.crecheUrbana3Parcial,
        r?.crecheUrbana3Integral,
        r?.crecheCampo3Parcial,
        r?.crecheCampo3Integral,
        r?.crecheTerraIndigena3Parcial,
        r?.crecheTerraIndigena3Integral,
        r?.crecheQuilombola3Parcial,
        r?.crecheQuilombola3Integral,
      ),
      preEscola: this.resultadoEtapa1?.preEscola || 0,
      ensFunAnosIniciais: this.resultadoEtapa1?.ensFunAnosIniciais || 0,
      ensFunAnosFinais: this.resultadoEtapa1?.ensFunAnosFinais || 0,
      ensMedio: this.resultadoEtapa1?.ensMedio || 0,
      eja: this.resultadoEtapa1?.eja || 0,
    };
  }

  crieParametrosGraficoMatriculasPorAreaLocalidade() {
    const r = this.resultadoEtapa1 as ResultadoMatriculasPorEtapa;
    this.parametrosGraficoMatriculasPorAreaLocalidade = {
      crecheUrbana:
        (r?.crecheUrbanaIndepLocDiferenciadaIntegral || 0) +
        (r?.crecheUrbanaIndepLocDiferenciadaParcial || 0),

      crecheRural:
        (this.resultadoEtapa1?.crecheRuralIntegral || 0) +
        (this.resultadoEtapa1?.crecheRuralParcial || 0),

      preEscolaUrbana:
        (r?.preEscolaUrbanaIndepLocDiferenciadaIntegral || 0) +
        (r?.preEscolaUrbanaIndepLocDiferenciadaParcial || 0),

      preEscolaRural:
        (this.resultadoEtapa1?.preEscolaRuralIntegral || 0) +
        (this.resultadoEtapa1?.preEscolaRuralParcial || 0),

      ensFunAnosIniciaisUrbana:
        (r?.ensFunAnosIniciaisUrbanaIndepLocDiferenciadaIntegral || 0) +
        (r?.ensFunAnosIniciaisUrbanaIndepLocDiferenciadaParcial || 0),

      ensFunAnosIniciaisRural:
        (this.resultadoEtapa1?.ensFunAnosIniciaisRuralIntegral || 0) +
        (this.resultadoEtapa1?.ensFunAnosIniciaisRuralParcial || 0),

      ensFunAnosFinaisUrbana:
        (r?.ensFunAnosFinaisUrbanaIndepLocDiferenciadaIntegral || 0) +
        (r?.ensFunAnosFinaisUrbanaIndepLocDiferenciadaParcial || 0),

      ensFunAnosFinaisRural:
        (this.resultadoEtapa1?.ensFunAnosFinaisRuralIntegral || 0) +
        (this.resultadoEtapa1?.ensFunAnosFinaisRuralParcial || 0),

      ensMedioUrbana:
        (r?.ensMedioUrbanaIndepLocDiferenciadaIntegral || 0) +
        (r?.ensMedioUrbanaIndepLocDiferenciadaParcial || 0),

      ensMedioRural:
        (this.resultadoEtapa1?.ensMedioRuralParcial || 0) +
        (this.resultadoEtapa1?.ensMedioRuralIntegral || 0),

      ejaUrbana:
        (r?.ejaUrbanaIndepLocDiferenciadaParcial || 0) +
        (r?.ejaUrbanaIndepLocDiferenciadaIntegral || 0),
      ejaRural:
        (this.resultadoEtapa1?.ejaRuralParcial || 0) +
        (this.resultadoEtapa1?.ejaRuralIntegral || 0),
    };
  }

  async calcularDadosFinanceiros() {
    const diferencaOrcamento =
      await this.planejamentoOrcamentarioService.buscarDiferencaOrcamentoRealizadoProjetadoPorLocalizacao();

    const despesaNecessaria =
      this.memoriaCalculo?.resultadoDistribuicaoDespesaPorEtapa
        ?.despesaNecessaria ?? 0;
    const totalMatriculas = this.resultadoEtapa1?.total ?? 0;

    const localizacao = this.localizacaoService.obterLocalizacaoSelecionada();
    const tipoSimulacao = localizacao?.tipoSimulacaoSelecionado;

    let receitaPotencial = 0;
    let despesaRealizada = 0;

    const isPlano =
      tipoSimulacao === TipoSimulacao.planejamento ||
      tipoSimulacao === TipoSimulacao.planejamentoNacional;

    const isRedeMunicipal =
      tipoSimulacao === TipoSimulacao.planejamentoPorEsferaAdmMunicipal;
    const isRedeEstadual =
      tipoSimulacao === TipoSimulacao.planejamentoPorEsferaAdmEstadual;

    // se plano, mostrar municipal + estadual
    // se rede, estadual ou municipal
    if (isPlano) {
      receitaPotencial =
        (diferencaOrcamento.receitaPotencialMunicipal ?? 0) +
        (diferencaOrcamento.receitaPotencialEstadual ?? 0);

      despesaRealizada =
        (diferencaOrcamento.despesaRealizadaMunicipal ?? 0) +
        (diferencaOrcamento.despesaRealizadaEstadual ?? 0);
    } else if (isRedeMunicipal && localizacao?.cidadeSelecionada) {
      receitaPotencial = diferencaOrcamento.receitaPotencialMunicipal ?? 0;
      despesaRealizada = diferencaOrcamento.despesaRealizadaMunicipal ?? 0;
    } else if (
      isRedeEstadual &&
      localizacao?.estadoSelecionado &&
      !localizacao.cidadeSelecionada
    ) {
      receitaPotencial = diferencaOrcamento.receitaPotencialEstadual ?? 0;
      despesaRealizada = diferencaOrcamento.despesaRealizadaEstadual ?? 0;
    }

    const valorCaqAno =
      totalMatriculas > 0 ? despesaNecessaria / totalMatriculas : 0;
    const valorCaqMes = valorCaqAno / 12;

    let complementacao = 0;
    let porcentagemComplementacao = 0;

    if (this.memoriaCalculo?.complementacaoDto) {
      const compMunicipal =
        this.memoriaCalculo.complementacaoDto.complementacaoNivelMunicipio ?? 0;
      const compEstadual =
        this.memoriaCalculo.complementacaoDto.complementacaoNivelEstado ?? 0;

      complementacao = compMunicipal + compEstadual;

      let receitaComComplementacao = 0;
      receitaComComplementacao += diferencaOrcamento.receitaPotencialMunicipal;
      receitaComComplementacao += diferencaOrcamento.receitaPotencialEstadual;

      porcentagemComplementacao =
        receitaComComplementacao > 0
          ? complementacao / receitaComComplementacao
          : 0;
    }

    const RPEBAposVaatCaq = receitaPotencial + complementacao;
    const valorAlunoAnoRPEB =
      totalMatriculas == 0 ? 0 : receitaPotencial / totalMatriculas;
    const valorAlunoAnoAposVaatCaq =
      totalMatriculas == 0 ? 0 : RPEBAposVaatCaq / totalMatriculas;
    const valorAlunoMesAposVaatCaq = valorAlunoAnoAposVaatCaq / 12;
    const complementacaoVaatCaqPercentual =
      (valorAlunoAnoAposVaatCaq / receitaPotencial - 1) * 100;

    this.parametrosFinanciamentoDto = {
      receitaPotencialMinima: receitaPotencial,
      despesaRealizada: despesaRealizada,
      despesaNecessaria: despesaNecessaria,
      complementacao: complementacao,
      porcentagemComplementacao: porcentagemComplementacao,
      valorCaqAno: valorCaqAno,
      valorCaqMes: valorCaqMes,
      RPEBAposVaatCaq: RPEBAposVaatCaq,
      valorAlunoAnoRPEB: valorAlunoAnoRPEB,
      valorAlunoAnoAposVaatCaq: valorAlunoAnoAposVaatCaq,
      valorAlunoMesAposVaatCaq: valorAlunoMesAposVaatCaq,
      complementacaoVaatCaqPercentual: complementacaoVaatCaqPercentual,
      media: 0,
      menor: 0,
      primeiroQuartil: 0,
      mediana: 0,
      terceiroQuartil: 0,
      maior: 0,
      creche: 0,
      preEscola: 0,
      ensAnosIniciais: 0,
      ensAnosFinais: 0,
      ensMedio: 0,
      eja: 0,
    };

    this.cdr.detectChanges();
  }

  definaLarguraGraficoNumeroTurmas() {
    const proporcaoMaximaEmPx = 600;
    const totalTurmas =
      this.quantidadeTurmasExistentes + this.quantidadeTurmasNecessarias;
    this.larguraQuantidadeTurmasExistentes = +(
      (this.quantidadeTurmasExistentes / totalTurmas) *
      proporcaoMaximaEmPx
    ).toFixed(2);
    this.larguraQuantidadeTurmasNecessarias = +(
      (this.quantidadeTurmasNecessarias / totalTurmas) *
      proporcaoMaximaEmPx
    ).toFixed(2);
  }

  definaLarguraGraficoNumeroDocentes() {
    const proporcaoMaximaEmPx = 600;
    const totalDocentes =
      this.quantidadeDocentesExistentes + this.quantidadeDocentesNecessarias;
    this.larguraQuantidadeDocentesExistentes = +(
      (this.quantidadeDocentesExistentes / totalDocentes) *
      proporcaoMaximaEmPx
    ).toFixed(2);
    this.larguraQuantidadeDocentesNecessarias = +(
      (this.quantidadeDocentesNecessarias / totalDocentes) *
      proporcaoMaximaEmPx
    ).toFixed(2);
  }

  definaLarguraGraficoNumeroFuncionarios() {
    const proporcaoMaximaEmPx = 600;
    const totalFuncionarios =
      this.quantidadeFuncionariosExistentes +
      this.quantidadeFuncionariosNecessarias;
    this.larguraQuantidadeFuncionariosExistentes = +(
      (this.quantidadeFuncionariosExistentes / totalFuncionarios) *
      proporcaoMaximaEmPx
    ).toFixed(2);
    this.larguraQuantidadeFuncionariosNecessarias = +(
      (this.quantidadeFuncionariosNecessarias / totalFuncionarios) *
      proporcaoMaximaEmPx
    ).toFixed(2);
  }

  definaPorcentagemNumeroTurmas() {
    if (this.quantidadeTurmasExistentes === 0) {
      this.porcentagemInformacaoNumeroTurmas = 0;
      this.numeroTurmasExistentesEhMaior = false;
      return;
    }

    this.porcentagemInformacaoNumeroTurmas =
      this.quantidadeTurmasNecessarias / this.quantidadeTurmasExistentes - 1;
    this.numeroTurmasExistentesEhMaior =
      this.quantidadeTurmasExistentes > this.quantidadeTurmasNecessarias;
  }

  definaPorcentagemNumeroDocentes() {
    if (this.quantidadeDocentesExistentes === 0) {
      this.porcentagemInformacaoNumeroDocentes = 0;
      this.numeroDocentesExistentesEhMaior = false;
      return;
    }

    this.porcentagemInformacaoNumeroDocentes =
      this.quantidadeDocentesNecessarias / this.quantidadeDocentesExistentes -
      1;
    this.numeroDocentesExistentesEhMaior =
      this.quantidadeDocentesExistentes > this.quantidadeDocentesNecessarias;
  }

  definaPorcentagemNumeroFuncionarios() {
    if (this.quantidadeFuncionariosExistentes === 0) {
      this.porcentagemInformacaoNumeroFuncionarios = 0;
      this.numeroFuncionariosExistentesEhMaior = false;
      return;
    }

    this.porcentagemInformacaoNumeroFuncionarios =
      this.quantidadeFuncionariosNecessarias /
        this.quantidadeFuncionariosExistentes -
      1;
    this.numeroFuncionariosExistentesEhMaior =
      this.quantidadeFuncionariosExistentes >
      this.quantidadeFuncionariosNecessarias;
  }

  onSelecaoChange(novoValor: string): void {
    this.tipoFiltroSelecionado = novoValor;

    if (this.tipoFiltroSelecionado == '1') {
      this.chartOption =
        FabricaGraficosRelatorioFinanciamentoEscolas.crieConfiguracaoGraficoTotalMatriculas(
          this.parametrosGraficoTotalMatriculas,
          this.totalMatriculas,
          this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade'),
        );
      return;
    }

    if (this.resultadoEtapa1 != null) {
      this.chartOption =
        this.tipoFiltroSelecionado == '2'
          ? FabricaGraficosRelatorioFinanciamentoEscolas.crieConfiguracaoGraficoMatriculasPorAreaLocalidade(
              this.parametrosGraficoMatriculasPorAreaLocalidade,
              this.resultadoEtapa1,
            )
          : FabricaGraficosRelatorioFinanciamentoEscolas.crieConfiguracaoGraficoMatriculasPorTurno(
              this.parametrosGraficoMatriculasPorTurno,
              this.resultadoEtapa1,
            );
    }
  }

  onSelecaoFiltroFinanciamentoChange(novoValor: string): void {
    this.tipoFiltroFinanciamentoSelecionado = novoValor;
    this.descricaoFiltroFinanciamentoSelecionado =
      this.tipoFiltroFinanciamentoSelecionado == '1' ? 'ano' : 'mês';
    this.atualizarEstatisticas().then(() => {
      // Forçar atualização da interface após mudança de filtro
      this.atualizarView();
    });
  }

  atualizarView(): void {
    this.cdr.markForCheck();
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
  }

  private get cacheEscolasCaqAtual(): CacheEscolasCaq | null {
    return this.tipoFiltroFinanciamentoSelecionado === '1'
      ? this.cacheAno
      : this.cacheMes;
  }

  getTotalEscolas(): number {
    return this.caqEscolas?.totalInstituicoes || 0;
  }

  private get escolas(): CaqEscolaResumoDto[] {
    return this.caqEscolas?.escolas ?? [];
  }

  // Monta cache com os valores do caq para evitar recálculo ao mudar o filtro mes/ano
  private construirValoresPorEscola(ehAno: boolean): CacheEscolasCaq {
    const faixasCaq = ehAno
      ? this.faixasCaqAnoCalculadas
      : CaqUtils.faixasCaqMes();

    const faixaCaq = this.calcularValorPorFaixaCaq(faixasCaq, ehAno);
    const localizacao = this.calcularCaqPorLocalidade(ehAno);
    const porte = this.calcularCaqPorteEscola(ehAno);

    return {
      ehAno,
      totalEscolas: this.escolas.length,
      faixaCaq,
      localizacao,
      porte,
    };
  }

  // Calcula a quantidade de escolas em cada faixa de CAQ
  private calcularValorPorFaixaCaq(
    faixas: readonly Faixa[],
    ehAno: boolean,
  ): EscolasPorFaixaCaq {
    const quantidade = new Array(faixas.length).fill(0);

    for (const escola of this.escolas) {
      const valorCaq = ehAno ? escola.caqAno : escola.caqMes;
      if (valorCaq <= 0) continue;

      const indiceFaixa = this.encontrarIndiceFaixa(valorCaq, faixas);

      if (indiceFaixa >= 0) quantidade[indiceFaixa]++;
    }

    return { quantidade };
  }

  // Calcula quantidade e média do CAQ por tipo de localização (Urbana, Rural, Diferenciada)
  private calcularCaqPorLocalidade(ehAno: boolean): EscolasPorLocalizacao {
    const quantidadePorLocalizacao: Record<string, number> = {};
    const somaPorLocalizacao: Record<string, number> = {};
    const contadorPorLocalizacao: Record<string, number> = {};

    const qntdPorLocDiferenciada: Record<string, number> = {};
    const somaPorLocDiferenciada: Record<string, number> = {};
    const contadorPorLocDiferenciada: Record<string, number> = {};

    // Agrega quantidade e soma por localização
    for (const escola of this.escolas) {
      const tipoLocalizacao = escola.localizacao || 'DESCONHECIDA';
      const tipoLocalizacaoDiferenciada =
        escola.localizacaoDiferenciada || 'DESCONHECIDA';

      quantidadePorLocalizacao[tipoLocalizacao] =
        (quantidadePorLocalizacao[tipoLocalizacao] ?? 0) + 1;
      qntdPorLocDiferenciada[tipoLocalizacaoDiferenciada] =
        (qntdPorLocDiferenciada[tipoLocalizacaoDiferenciada] ?? 0) + 1;

      const valorCaq = ehAno ? escola.caqAno : escola.caqMes;
      if (valorCaq > 0) {
        somaPorLocalizacao[tipoLocalizacao] =
          (somaPorLocalizacao[tipoLocalizacao] ?? 0) + valorCaq;
        contadorPorLocalizacao[tipoLocalizacao] =
          (contadorPorLocalizacao[tipoLocalizacao] ?? 0) + 1;

        somaPorLocDiferenciada[tipoLocalizacaoDiferenciada] =
          (somaPorLocDiferenciada[tipoLocalizacaoDiferenciada] ?? 0) + valorCaq;
        contadorPorLocDiferenciada[tipoLocalizacaoDiferenciada] =
          (contadorPorLocDiferenciada[tipoLocalizacaoDiferenciada] ?? 0) + 1;
      }
    }

    // Calcula médias e identifica o maior valor de média para uso na escala de gráficos
    const mediaPorLocalizacao: Record<string, number> = {};
    let maxMedia = 0;

    for (const tipoLocalizacao of Object.keys(quantidadePorLocalizacao)) {
      const quantidadeComMedia = contadorPorLocalizacao[tipoLocalizacao] ?? 0;
      const mediaLocalizacao =
        quantidadeComMedia > 0
          ? somaPorLocalizacao[tipoLocalizacao] / quantidadeComMedia
          : 0;

      mediaPorLocalizacao[tipoLocalizacao] = mediaLocalizacao;
      if (mediaLocalizacao > maxMedia) maxMedia = mediaLocalizacao;
    }

    const mediaPorLocDiferenciada: Record<string, number> = {};
    let maxMediaDiferenciada = 0;

    for (const tpLocDiferenciada of Object.keys(qntdPorLocDiferenciada)) {
      const quantidadeComMedia =
        contadorPorLocDiferenciada[tpLocDiferenciada] ?? 0;
      const mediaLocalizacaoDiferenciada =
        quantidadeComMedia > 0
          ? somaPorLocDiferenciada[tpLocDiferenciada] / quantidadeComMedia
          : 0;

      mediaPorLocDiferenciada[tpLocDiferenciada] = mediaLocalizacaoDiferenciada;

      if (mediaLocalizacaoDiferenciada > maxMediaDiferenciada)
        maxMediaDiferenciada = mediaLocalizacaoDiferenciada;
    }

    return {
      quantidade: quantidadePorLocalizacao,
      mediaCaqPorLocalizacao: mediaPorLocalizacao,
      maiorMediaCaq: maxMedia,
      quantidadePorDiferenciada: qntdPorLocDiferenciada,
      mediaCaqPorDiferenciada: mediaPorLocDiferenciada,
      maiorMediaCaqPorDiferenciada: maxMediaDiferenciada,
    };
  }
  // Calcula quantidade e média do CAQ por porte de escola (número de matrículas)
  private calcularCaqPorteEscola(ehAno: boolean): EscolasPorPorte {
    const totalFaixasPorte = this.faixasPorteEscola.length;
    const quantidadePorFaixa = new Array(totalFaixasPorte).fill(0);
    const somaPorFaixa = new Array(totalFaixasPorte).fill(0);
    const contadorPorFaixa = new Array(totalFaixasPorte).fill(0);

    // classifica porte e acumula CAQ para média
    for (const escola of this.escolas) {
      const totalMatriculas = Number(escola.totalMatriculas ?? 0);

      const indiceFaixaPorte = this.encontrarIndiceFaixaPorte(totalMatriculas);

      quantidadePorFaixa[indiceFaixaPorte]++;

      const valorCaq = ehAno ? escola.caqAno : escola.caqMes;
      if (valorCaq > 0) {
        somaPorFaixa[indiceFaixaPorte] += valorCaq;
        contadorPorFaixa[indiceFaixaPorte]++;
      }
    }

    // fecha médias e acha o maior para escalar barras
    const mediaPorFaixa = somaPorFaixa.map((soma, i) =>
      contadorPorFaixa[i] > 0 ? soma / contadorPorFaixa[i] : 0,
    );
    const maxMedia = Math.max(...mediaPorFaixa);

    return {
      quantidade: quantidadePorFaixa,
      mediaCaqPorPorte: mediaPorFaixa,
      maiorMediaCaq: maxMedia,
    };
  }

  // Retorna o índice da faixa de CAQ correspondente ao valor
  private encontrarIndiceFaixa(
    valor: number,
    faixas: readonly Faixa[],
  ): number {
    for (let i = 0; i < faixas.length; i++) {
      const faixa = faixas[i];
      const primeira = i === 0;
      const ultima = i === faixas.length - 1;

      if (primeira && valor <= faixa.max) return i;
      if (ultima && valor > faixa.min) return i;
      if (!primeira && !ultima && valor > faixa.min && valor <= faixa.max)
        return i;
    }
    return -1;
  }

  // Retorna o índice da faixa de porte correspondente
  private encontrarIndiceFaixaPorte(matriculas: number): number {
    for (let i = 0; i < this.faixasPorteEscola.length; i++) {
      const faixa = this.faixasPorteEscola[i];
      const ultima = i === this.faixasPorteEscola.length - 1;
      if (
        ultima
          ? matriculas >= faixa.min
          : matriculas >= faixa.min && matriculas <= faixa.max
      )
        return i;
    }
    return -1;
  }

  // Escolas por Faixa CAQ
  getEscolasPorFaixaCaq(faixaIndex: number): number {
    return this.cacheEscolasCaqAtual?.faixaCaq.quantidade[faixaIndex] || 0;
  }
  getPorcentagemPorFaixaCaq(faixaIndex: number): number {
    const total = this.cacheEscolasCaqAtual?.totalEscolas || 0;
    if (!total) return 0;
    return (this.getEscolasPorFaixaCaq(faixaIndex) / total) * 100;
  }

  getLarguraBarraPorFaixaCaq(faixaIndex: number): number {
    const total = this.cacheEscolasCaqAtual?.totalEscolas || 0;
    if (!total) return 0;
    return Math.round((this.getEscolasPorFaixaCaq(faixaIndex) / total) * 170);
  }

  getDescricaoFaixaCaq(faixaIndex: number): string {
    const ehAno = this.tipoFiltroFinanciamentoSelecionado === '1';

    const valoresFixosMes = [800, 1200, 1600, 2000];

    const valoresFixosAno = valoresFixosMes.map((v) => v * 12);

    const valores = ehAno ? valoresFixosAno : valoresFixosMes;
    const formatar = (valor: number) =>
      Math.round(valor).toLocaleString('pt-BR');

    const nbsp = '\u00A0';

    if (faixaIndex === 0) return `≤${nbsp}${formatar(valores[0])}`;
    if (faixaIndex === 1)
      return `>${nbsp}${formatar(valores[0])} ≤${nbsp}${formatar(valores[1])}`;
    if (faixaIndex === 2)
      return `>${nbsp}${formatar(valores[1])} ≤${nbsp}${formatar(valores[2])}`;
    if (faixaIndex === 3)
      return `>${nbsp}${formatar(valores[2])} ≤${nbsp}${formatar(valores[3])}`;
    if (faixaIndex === 4) return `>${nbsp}${formatar(valores[3])}`;

    return '';
  }

  // Escolas por Localização
  getEscolasPorLocalizacao(tipoLocalizacao: string): number {
    return (
      this.cacheEscolasCaqAtual?.localizacao.quantidade[tipoLocalizacao] || 0
    );
  }

  getEscolasPorLocalizacaoDiferenciada(tipoLocalizacao: string): number {
    return (
      this.cacheEscolasCaqAtual?.localizacao.quantidadePorDiferenciada[
        tipoLocalizacao
      ] || 0
    );
  }

  getMediaCaqPorLocalizacao(tipoLocalizacao: string): number | null {
    const media =
      this.cacheEscolasCaqAtual?.localizacao.mediaCaqPorLocalizacao[
        tipoLocalizacao
      ] || 0;
    return media > 0 ? Math.round(media) : null;
  }
  getMediaCaqPorLocalizacaoDiferenciada(
    tipoLocalizacao: string,
  ): number | null {
    const media =
      this.cacheEscolasCaqAtual?.localizacao.mediaCaqPorDiferenciada[
        tipoLocalizacao
      ] || 0;
    return media > 0 ? Math.round(media) : null;
  }

  getLarguraBarraCaqPorLocalizacao(tipoLocalizacao: string): number {
    const cache = this.cacheEscolasCaqAtual;
    if (!cache || cache.localizacao.maiorMediaCaq === 0) return 0;
    const media =
      cache.localizacao.mediaCaqPorLocalizacao[tipoLocalizacao] || 0;
    return Math.round((media / cache.localizacao.maiorMediaCaq) * 170);
  }

  getLarguraBarraCaqPorLocalizacaoDiferenciada(
    tipoLocalizacao: string,
  ): number {
    const cache = this.cacheEscolasCaqAtual;
    if (!cache || cache.localizacao.maiorMediaCaqPorDiferenciada === 0)
      return 0;
    const media =
      cache.localizacao.mediaCaqPorDiferenciada[tipoLocalizacao] || 0;
    return Math.round(
      (media / cache.localizacao.maiorMediaCaqPorDiferenciada) * 170,
    );
  }

  // Escolas por Porte
  getEscolasPorFaixaPorte(faixaIndex: number): number {
    return this.cacheEscolasCaqAtual?.porte.quantidade[faixaIndex] || 0;
  }

  getMediaCaqPorFaixaPorte(faixaIndex: number): number | null {
    const media =
      this.cacheEscolasCaqAtual?.porte.mediaCaqPorPorte[faixaIndex] || 0;
    return media > 0 ? Math.round(media) : null;
  }

  getLarguraBarraCaqPorFaixaPorte(faixaIndex: number): number {
    const cache = this.cacheEscolasCaqAtual;
    if (!cache || cache.porte.maiorMediaCaq === 0) return 0;
    const media = cache.porte.mediaCaqPorPorte[faixaIndex] || 0;
    return Math.round((media / cache.porte.maiorMediaCaq) * 170);
  }

  getDescricaoFaixaPorte(faixaIndex: number): string {
    if (faixaIndex < 0 || faixaIndex >= this.faixasPorteEscola.length)
      return '';

    const f = this.faixasPorteEscola[faixaIndex];
    if (faixaIndex === 0) return `≤ ${f.max.toLocaleString('pt-BR')}`;
    if (faixaIndex === this.faixasPorteEscola.length - 1)
      return `> ${f.min.toLocaleString('pt-BR')}`;
    return `${f.min.toLocaleString('pt-BR')} - ${f.max.toLocaleString('pt-BR')}`;
  }

  // Atualiza os dados estatísticos quando muda o período (ano/mês) ou após carregar as escolas
  private async atualizarEstatisticas(
    novosDadosForamAdicionados: boolean = false,
  ): Promise<void> {
    const ehAno =
      this.tipoFiltroFinanciamentoSelecionado === '1' ? true : false;

    // Quando a feature flag estiver habilitada, os dados estatísticos vêm do serviço de backend
    if (
      this.featureFlagService.funcionalidadeHabilitada(
        '1214-alteracoes-valor-aluno',
      )
    ) {
      // Consulta o backend apenas para o ano e somente se novos dados foram adicionados ou ainda não há cache;
      // ao selecionar o mês reutilizamos os dados anuais salvos, dividindo por 12
      if (!this.estatisticasCaqBackend || novosDadosForamAdicionados) {
        const estatisticasBackend = await this.buscarEstatisticasBackend(novosDadosForamAdicionados);
        if (estatisticasBackend) {
          this.estatisticasCaqBackend = estatisticasBackend;
        }
      }

      if (this.estatisticasCaqBackend) {
        // Os valores retornados pelo backend são anuais; quando o filtro for mês ("2"), dividir por 12
        this.dadosEstatisticos = ehAno
          ? this.estatisticasCaqBackend
          : this.converterEstatisticasParaMes(this.estatisticasCaqBackend);
        return;
      }
    }

    this.dadosEstatisticos = this.calcularEstatisticasCaq(ehAno);
  }

  // Cache dos dados estatísticos anuais retornados pelo backend
  private estatisticasCaqBackend: EstatisticasCaq | null = null;

  // Busca os dados estatísticos no backend de acordo com a localização selecionada
  private async buscarEstatisticasBackend(novosDadosForamAdicionados: boolean = false): Promise<EstatisticasCaq | null> {
    const localizacao = this.localizacaoSelecionada;
    const tipo = localizacao?.tipoSimulacaoSelecionado;

    try {
      const requisicao = novosDadosForamAdicionados
        ? this.criarRequisicao()
        : null;
      if (!localizacao || tipo === TipoSimulacao.planejamentoNacional) {
        return this.validarEstatisticas(
          await this.estatisticasCaqService.buscarEstatisticasNacional(
            requisicao,
          ),
        );
      }

      if (
        tipo === TipoSimulacao.planejamento &&
        localizacao.estadoSelecionado &&
        !localizacao.cidadeSelecionada
      ) {
        return this.validarEstatisticas(
          await this.estatisticasCaqService.buscarEstatisticasPlanoEstado(
            localizacao.estadoSelecionado.value,
            requisicao
          ),
        );
      }
    } catch {
      return null;
    }

    return null;
  }

  private converterEstatisticasParaMes(
    estatisticas: EstatisticasCaq,
  ): EstatisticasCaq {
    return {
      media: estatisticas.media / 12,
      minimo: estatisticas.minimo / 12,
      primeiroQuartil: estatisticas.primeiroQuartil / 12,
      mediana: estatisticas.mediana / 12,
      terceiroQuartil: estatisticas.terceiroQuartil / 12,
      maximo: estatisticas.maximo / 12,
    };
  }

  private validarEstatisticas(
    estatisticas: EstatisticasCaq,
  ): EstatisticasCaq | null {
    if (
      !estatisticas ||
      Array.isArray(estatisticas) ||
      typeof estatisticas.maximo !== 'number'
    ) {
      return null;
    }
    return estatisticas;
  }

  private calcularEstatisticasCaq(ehAno: boolean): EstatisticasCaq {
    if (!this.escolas || this.escolas.length === 0) {
      return {
        media: 0,
        minimo: 0,
        primeiroQuartil: 0,
        mediana: 0,
        terceiroQuartil: 0,
        maximo: 0,
      };
    }

    // Extrai os valores do CAQ (ano ou mês) e filtra apenas os válidos (>0)
    // Considerando que a lista está vindo ordenada do backend
    const listaValoresCaq = this.escolas
      .filter((escola) => escola.totalMatriculas >= 21)
      .map((escola) =>
        ehAno ? Number(escola.caqAno ?? 0) : Number(escola.caqMes ?? 0),
      )
      .filter((valor) => Number.isFinite(valor) && valor > 0);

    const totalValores = listaValoresCaq.length;

    // Média
    const somaTotal = listaValoresCaq.reduce(
      (acumulado, valor) => acumulado + valor,
      0,
    );
    const media = somaTotal / totalValores;

    // Mínimo e máximo
    const minimo = listaValoresCaq[0];
    const maximo = listaValoresCaq[totalValores - 1];

    // Quartis
    const primeiroQuartil = this.calcularPercentil(listaValoresCaq, 0.25);
    const mediana = this.calcularPercentil(listaValoresCaq, 0.5);
    const terceiroQuartil = this.calcularPercentil(listaValoresCaq, 0.75);

    return { media, minimo, primeiroQuartil, mediana, terceiroQuartil, maximo };
  }

  private calcularPercentil(valores: number[], percentual: number): number {
    const quantidade = valores.length;

    if (quantidade === 0) return 0;

    const posicao = (quantidade - 1) * percentual;
    const indiceBase = Math.floor(posicao);
    const fracao = posicao - indiceBase;

    if (indiceBase + 1 >= quantidade) return valores[quantidade - 1];

    // Uso de interpolação linear para encontrar o percentil
    return (
      valores[indiceBase] +
      fracao * (valores[indiceBase + 1] - valores[indiceBase])
    );
  }

  larguraBarraEstatisticas(valor: number) {
    const largura = Math.round((valor / this.dadosEstatisticos.maximo) * 290);
    return Math.min(largura, 290);
  }

  private ehLocalizacaoMunicipal(): boolean {
    const tipo = this.localizacaoSelecionada?.tipoSimulacaoSelecionado;
    const isMunicipal =
      !!this.localizacaoSelecionada?.cidadeSelecionada &&
      (tipo === TipoSimulacao.planejamento ||
        tipo === TipoSimulacao.planejamentoPorEsferaAdmMunicipal);

    return isMunicipal;
  }

  private definirNomeCSV(): string {
    const localizacao = this.localizacaoSelecionada;
    const tipoSimulacao = localizacao?.tipoSimulacaoSelecionado;
    const prefixo =
      tipoSimulacao === TipoSimulacao.planejamento ? 'plano' : 'rede';

    let nome = 'financiamento-entes-federados-';

    if (localizacao?.cidadeSelecionada) {
      nome = nome + prefixo + '-' + localizacao.cidadeSelecionada.value;
    } else {
      if (localizacao?.estadoSelecionado) {
        nome = nome + prefixo + '-' + localizacao.estadoSelecionado.value;
      } else {
        nome = nome + '-nacional-analitico';
      }
    }

    return nome;
  }

  downloadResultados(formato: FormatoResultado): void {
    this.carregamentoService.startLoading();
    this.layoutResultadoService
      .getRotaDownloadResultado()
      .subscribe((rota) => {
        const novosDadosForamAdicionados = this.verificaNovosDadosAdicionados();

        const requisicao = novosDadosForamAdicionados
          ? this.criarRequisicao()
          : null;

        this.layoutResultadoService
          .baixarResultado(
            rota,
            novosDadosForamAdicionados ? requisicao : requisicao,
            formato,
          )
          .subscribe({
            next: (blob) => {
              const a = document.createElement('a');
              const objectUrl = URL.createObjectURL(blob);

              a.href = objectUrl;
              a.download = this.definirNomeCSV() + `.${formato.toLowerCase()}`;
              a.click();

              URL.revokeObjectURL(objectUrl);
              this.carregamentoService.finishLoading();
            },
            error: (err) => {
              console.error('Erro ao baixar o arquivo', err);
              this.carregamentoService.finishLoading();
            },
          });
      })
      .unsubscribe();
  }

  private definirDownloads(): void {
    const textoBase = this.obterTextoDownloadPorLocalidade();

    this.layoutResultadoService.setDownloads([
      {
        acao: (): void => this.downloadResultados('CSV'),
        texto: `${textoBase} em CSV`,
        tipo: 'acao',
      },
      {
        acao: (): void => this.downloadResultados('PDF'),
        texto: `${textoBase} em PDF`,
        tipo: 'acao',
      },
    ]);
  }

  private obterTextoDownloadPorLocalidade(): string {
    const localizacao = this.localizacaoSelecionada;

    if (localizacao?.cidadeSelecionada) {
      return 'Baixar dados do Município';
    }

    if (localizacao?.estadoSelecionado) {
      return 'Baixar dados por localidade da UF';
    }

    return 'Baixar dados por localidade do Brasil';
  }

  // Calcula as 5 faixas de CAQ usando valores fixos
  private calcularFaixasCaqAno(): Faixa[] {
    // Valores fixos para mês: 800, 1200, 1600, 2000
    // Para ano, multiplica por 12: 9600, 14400, 19200, 24000
    const valoresFixosMes = [800, 1200, 1600, 2000];
    const valoresFixosAno = valoresFixosMes.map((v) => v * 12);

    return [
      { min: 0, max: valoresFixosAno[0] },
      { min: valoresFixosAno[0], max: valoresFixosAno[1] },
      { min: valoresFixosAno[1], max: valoresFixosAno[2] },
      { min: valoresFixosAno[2], max: valoresFixosAno[3] },
      { min: valoresFixosAno[3], max: Number.MAX_VALUE },
    ];
  }

  chamarAcao(acao: string): void {
    const escolhido = this.opcoesFiltroLocalizacao.filter(
      (f) => f.acao === acao,
    );

    if (escolhido.length > 0) {
      this.filtroLocalizacaoEscolhido = escolhido[0];
      return;
    }

    this.filtroLocalizacaoEscolhido = this.opcoesFiltroLocalizacao[0];
  }
}
